"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _getTrialState = _interopRequireDefault(require("self-service-api/api/getTrialState"));

var _UpgradeProducts = require("self-service-api/constants/UpgradeProducts");

var _sources = require("../data/upgradeData/properties/sources");

var _ActivationErrorModal = _interopRequireDefault(require("./ActivationErrorModal"));

var _ActivationSuccessModal = _interopRequireDefault(require("./ActivationSuccessModal"));

var MODAL_STATES = {
  LOADING: 'LOADING',
  SHOW_SUCCESS_MODAL: 'SHOW_SUCCESS_MODAL',
  SHOW_ERROR_MODAL: 'SHOW_ERROR_MODAL'
};

var RemoteToolsActivationErrorModal = function RemoteToolsActivationErrorModal(_ref) {
  var error = _ref.error,
      onSuccess = _ref.onSuccess;
  var shouldCheckTrialState = error.status === 400 && error.responseText.includes('overlapping');

  var _useState = (0, _react.useState)(shouldCheckTrialState ? MODAL_STATES.LOADING : MODAL_STATES.SHOW_ERROR_MODAL),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      modalState = _useState2[0],
      setModalState = _useState2[1];

  (0, _react.useEffect)(function () {
    if (shouldCheckTrialState) {
      (0, _getTrialState.default)().then(function (trialState) {
        var inTrial = trialState && trialState[_UpgradeProducts.TEMPORARY_REMOTE_TOOLS] && trialState[_UpgradeProducts.TEMPORARY_REMOTE_TOOLS].inTrial;

        if (inTrial) {
          setModalState(MODAL_STATES.SHOW_SUCCESS_MODAL);
        } else {
          setModalState(MODAL_STATES.SHOW_ERROR_MODAL);
        }
      }).catch(function () {
        setModalState(MODAL_STATES.SHOW_ERROR_MODAL);
      }).done();
    }

    return undefined;
  }, [shouldCheckTrialState]);

  switch (modalState) {
    case MODAL_STATES.SHOW_ERROR_MODAL:
    default:
      return _react.default.createElement(_ActivationErrorModal.default, null);

    case MODAL_STATES.SHOW_SUCCESS_MODAL:
      return _react.default.createElement(_ActivationSuccessModal.default, {
        type: _sources.sourceKeys.TRIAL,
        onSuccess: onSuccess,
        header: _react.default.createElement(_FormattedMessage.default, {
          message: "upgrades.activationModal.remoteToolsActivationModal.header"
        }),
        subText: _react.default.createElement(_FormattedMessage.default, {
          message: "upgrades.activationModal.remoteToolsActivationModal.body"
        }),
        ctaText: _react.default.createElement(_FormattedMessage.default, {
          message: "upgrades.activationModal.remoteToolsActivationModal.header"
        }),
        showIllustration: false
      });

    case MODAL_STATES.LOADING:
      return null;
  }
};

var _default = RemoteToolsActivationErrorModal;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/common/components/RemoteToolsActivationErrorModal.js
// module id = 762
// module chunks = 5 6